export default {
  name      : 'BrandCard',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    item: {
      type   : Object,
      default: () => {
        return {
          Name : '',
          Desc : '',
          Image: ''
        }
      }
    },

    hover: {
      type   : Boolean,
      default: false
    },

    dense: {
      type   : Boolean,
      default: false
    }

  },
  enums: {},
  data() {
    return {}
  },
  computed: {
    imageHeight() {
      if (this.$vuetify.breakpoint.xs) return this.dense ? 90 : 110
      if (this.$vuetify.breakpoint.sm) return this.dense ? 95 : 165
      if (this.$vuetify.breakpoint.md) return this.dense ? 100 : 180
      if (this.$vuetify.breakpoint.lg) return this.dense ? 105 : 220

      return this.dense ? 110 : 240
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
